import { DialogActions } from '@mui/material';
import { FactoringRequest } from 'pages/Finance/Components/Financing/Factoring/components/Recieved';
import React from 'react';

import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import InforPreview from '../../../../../../../../../common/InforPreview';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';

interface ShoppingCartFactoringInTransferProps {
  setOpenShoppingcart: (openShoppingcart: boolean) => void;
  selectedRequest: FactoringRequest;
}

const ShoppingCartFactoringInTransfer = (
  props: ShoppingCartFactoringInTransferProps,
) => {
  const { setOpenShoppingcart, selectedRequest } = props;

  const infoDiv = (
    <InforPreview
      requestType="factoring"
      selectedRequest={selectedRequest}
      status="En giro"
      type="Sent"
    />
  );

  return (
    <div>
      <SimulationDoneFrozen
        selectedRequest={selectedRequest}
        infoDiv={infoDiv}
      />
      <DialogActions>
        <CustomButton
          onClick={() => setOpenShoppingcart(false)}
          color="secondary"
        >
          Salir
        </CustomButton>
      </DialogActions>
    </div>
  );
};

export default ShoppingCartFactoringInTransfer;
